"use client";
import { usePublicT } from "../../public-locale";


import Link from "./MarketingLink";
import Logo from "./Logo";
import { useTheme } from "../contexts/ThemeContext";

const nav = [
  {
    title: "Platform",
    links: [
      { to: "/platform", label: "Overview" },
      { to: "/reviews", label: "Reviews & Reputation" },
      { to: "/local-seo", label: "Local SEO" },
      { to: "/ai", label: "Optrixis AI" },
      { to: "/local-score", label: "Local Score" },
      { to: "/priority-actions", label: "Priority Actions" },
      { to: "/integrations", label: "Integrations" },
    ],
  },
  {
    title: "Industries",
    links: [
      { to: "/industries/restaurants", label: "Restaurants" },
      { to: "/industries/salons-spas", label: "Salons & Spas" },
      { to: "/industries/hotels", label: "Hotels & Hospitality" },
      { to: "/industries/healthcare", label: "Healthcare" },
      { to: "/industries/retail", label: "Retail" },
      { to: "/industries", label: "All industries" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/pricing", label: "Pricing" },
      { to: "/enterprise", label: "Enterprise" },
      { to: "/security", label: "Security & Trust" },
      { to: "/blog", label: "Insights" },
      { to: "/contact", label: "Contact" },
      { to: "/book-demo", label: "Book a demo" },
      { to: "/ma", label: "Morocco" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/data-deletion", label: "Data Deletion" },
      { to: "/faq", label: "FAQ" },
    ],
  },
];

export default function Footer() {
  const t = usePublicT();
  const { effective } = useTheme();
  const isDark = effective === "dark";

  return (
    <footer className="border-t" style={{ borderColor: "var(--border)", background: "var(--surface)" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-1">
            <Logo dark={isDark} className="h-7 mb-5" />
            <p className="text-sm leading-relaxed mb-4" style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t("The AI Local Growth Platform that helps your business get found, build trust, and grow.")}</p>
            <p className="text-xs font-semibold tracking-widest uppercase" style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: "0.12em" }}>{t("An Optrixis LLC Product")}</p>
          </div>
          <div className="lg:col-span-4 grid grid-cols-2 md:grid-cols-4 gap-8">
            {t(nav.map((col) => <div key={col.title}><h2 className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: "var(--muted)", fontFamily: "'Sora', sans-serif", letterSpacing: "0.1em" }}>{t(col.title)}</h2><ul className="space-y-2.5">{t(col.links.map((link) => <li key={link.to}><Link href={link.to} className="text-sm transition-colors duration-150 hover:text-brand" style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t(link.label)}</Link></li>))}</ul></div>))}
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 border-t" style={{ borderColor: "var(--border)" }}>
          <p className="text-xs" style={{ color: "var(--muted)", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{t("© 2026 Optrixis LLC. OPTRIXIS LOCAL is an Optrixis LLC product.")}</p>
          <div className="flex items-center gap-6"><Link href="/privacy" className="text-xs transition-colors hover:text-brand" style={{ color: "var(--muted)" }}>{t("Privacy")}</Link><Link href="/terms" className="text-xs transition-colors hover:text-brand" style={{ color: "var(--muted)" }}>{t("Terms")}</Link><Link href="/data-deletion" className="text-xs transition-colors hover:text-brand" style={{ color: "var(--muted)" }}>{t("Data Deletion")}</Link></div>
        </div>
      </div>
    </footer>
  );
}
